import React from 'react';
import Icon from 'components/AppIcon';

const kpis = [
  { label: 'Total Revenue', value: '₱48.2M', change: '+12.4%', up: true, icon: 'DollarSign' },
  { label: 'Orders', value: '14,832', change: '+8.1%', up: true, icon: 'ShoppingCart' },
  { label: 'Active Accounts', value: '2,341', change: '-2.3%', up: false, icon: 'Users' },
  { label: 'Coverage %', value: '78.4%', change: '+3.2%', up: true, icon: 'Map' },
  { label: 'Avg Order Value', value: '₱3,249', change: '+4.7%', up: true, icon: 'TrendingUp' },
  { label: 'Target Attainment', value: '91.2%', change: '-1.8%', up: false, icon: 'Target' },
];

export default function KPISummaryBar({ period }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3 lg:gap-4">
      {kpis?.map((kpi) => (
        <div key={kpi?.label} className="card kpi-card-glow flex flex-col gap-1.5 min-w-0" style={{ padding: undefined }}>
          <div className="flex items-center justify-between">
            <span className="font-caption font-medium truncate" style={{ fontSize: '12px', color: '#475569' }}>{kpi?.label}</span>
            <Icon name={kpi?.icon} size={13} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <p className="font-heading font-bold kpi-value whitespace-nowrap" style={{ color: '#0F172A' }}>{kpi?.value}</p>
          <div className={`flex items-center gap-1 ${kpi?.up ? 'text-success' : 'text-destructive'}`}>
            <Icon name={kpi?.up ? 'TrendingUp' : 'TrendingDown'} size={11} strokeWidth={2.5} color="currentColor" />
            <span className="font-caption" style={{ fontSize: '11px', fontWeight: 500 }}>{kpi?.change} vs prev {period}</span>
          </div>
        </div>
      ))}
    </div>
  );
}